export default __webpack_public_path__ + "static/media/submenu-robot-S3.d689c4ec.png";